import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'aos/dist/aos.css';
import AOS from 'aos';
import './styles/global.css';
import Home from './pages/Home';
import BlogPage from './pages/Blog';
import SignupPage from './pages/Signup';
import LegalPage from './pages/Legal';
import DownloadDriver from './pages/DownloadDriver';
import Analytics from './components/Analytics';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <div className="App">
      <Analytics />
      {window.location.pathname === '/termos-de-uso.html'
        ? <LegalPage type="terms" />
        : window.location.pathname === '/politica-de-privacidade.html'
          ? <LegalPage type="privacy" />
          : window.location.pathname.startsWith('/blog')
        ? <BlogPage />
        : window.location.pathname.startsWith('/cadastro')
          ? <SignupPage />
          : window.location.pathname.startsWith('/download-app-driver')
            ? <DownloadDriver />
          : <Home />}
    </div>
  );
}

export default App;
